import { FormTextArea } from "components";
import { Fragment, useEffect } from "react";
import { additionalCommentsQuestions } from "./constants";

export const FourthPage = ({ register, errors, studentPrefix, setStudentPrefix }) => {
	useEffect(() => {
		setStudentPrefix(studentPrefix);
	}, []);

	return (
		<>
			{additionalCommentsQuestions.map((additionalComment, index) => (
				<Fragment key={index}>
					<FormTextArea
						register={register}
						prefix={"studentReport." + studentPrefix}
						formLabel={additionalComment.question}
						type="textarea"
						name={`additionalComments.${additionalComment.questionIndex}.answer`}
						required={true}
						validation={{
							validate: (value) => value.length || "Required Field",
						}}
						requiredErrorMessage="Required Field"
						error={errors.studentReport?.[studentPrefix]?.additionalComments?.[additionalComment.questionIndex]?.answer}
					/>
				</Fragment>
			))}
		</>
	);
};
